export default __webpack_public_path__ + "static/media/bgEllipse2.504fda40.svg";